import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { getOfficersDetails, getBlockByDistrict, getDistrict, getVillageByBlock } from '../../api/User';
import { ToastContainer, toast } from "react-toastify";
import "../Admin/table.css";
import TablePagination from '@mui/material/TablePagination';
import { FirstPage, LastPage, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';


const FrontlineWorkerOfficerAdmin = () => {
  const role_id = sessionStorage.getItem("role_id");
  const token = sessionStorage.getItem("token") || "";
  const gpID = (sessionStorage.getItem("gp_data") == 1 ? "all" : sessionStorage.getItem("gp_data")) || "";
  const userId = sessionStorage.getItem("user_id");
  const [district, setDistrict] = useState([]);
  const [selectedDistrictCode, setSelectedDistrictCode] = useState('');
  const [selectedDistrictName, setSelectedDistrictName] = useState('');
  const [selectedBlockCode, setSelectedBlockCode] = useState('');
  const [selectedBlockName, setSelectedBlockName] = useState('');
  const [selectedVillage, setSelectedVillage] = useState('');
  const [block, setBlock] = useState([]);
  const [village, setVillage] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const fetchData = async () => {
    const data = {
      role_id: role_id,
      id: userId,
      gp_data_id: gpID
    };
    try {
      const res = await getOfficersDetails(token, data);
      if (res.status === "success") {
        setFilteredData(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };
  const fetchDistrict = async () => {
    try {
      const res = await getDistrict(token, userId, role_id);
      if (res.status === 'success') {
        setDistrict(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error('Error fetching district data:', error);
      toast.error('An error occurred while fetching district data.', { autoClose: 1000 });
    }
  };

  const fetchBlockByDistrict = async (districtCode) => {
    try {
      const res = await getBlockByDistrict(token, districtCode, userId, role_id);
      if (res.status === 'success') {
        setBlock(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error('Error fetching block data:', error);
      toast.error('An error occurred while fetching block data.', { autoClose: 1000 });
    }
  };

  const fetchVillageByBlock = async (districtCode, blockCode) => {
    try {
      const res = await getVillageByBlock(token, districtCode, blockCode, userId, role_id);
      if (res.status === 'success') {
        setVillage(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error('Error fetching village data:', error);
      toast.error('An error occurred while fetching village data.', { autoClose: 1000 });
    }
  };

  const handleDistrictChange = (event) => {
    const selectedCode = event.target.value;
    const selectedDistrict = district.filter((item) => item.district_code == selectedCode);
    setSelectedDistrictCode(selectedCode);
    setSelectedBlockCode('');
    setSelectedVillage('');
    setBlock([]);
    setVillage([]);
    if (selectedCode) {
      fetchBlockByDistrict(selectedCode);
    }
    if (selectedCode) {
      setSelectedDistrictName(selectedDistrict[0].district);
    }
  };
  const handleBlockChange = (event) => {
    const selectedCode = event.target.value;
    const selectedBlock = block.filter((item) => item.block_code == selectedCode);
    setSelectedBlockCode(selectedCode);
    setSelectedVillage('');
    setVillage([]);
    if (selectedCode) {
      fetchVillageByBlock(selectedDistrictCode, selectedCode);
    }
    if (selectedBlock) {
      setSelectedBlockName(selectedBlock[0].block);
    }
  };
  const handleVillageChange = (event) => {
    const selectedCode = event.target.value;
    setSelectedVillage(selectedCode);

  };
  useEffect(() => {
    fetchData();
    fetchDistrict();
  }, []);
  const filteredRecords = filteredData.filter((row) => {
    let districtMatch = true;
    let blockMatch = true;
    let villageMatch = true;
    if (selectedDistrictCode) {
      districtMatch = row.district === selectedDistrictName;
    }
    if (selectedBlockCode) {
      blockMatch = row.block === selectedBlockName;
    }
    if (selectedVillage) {
      villageMatch = row.gram_panchayat === selectedVillage;
    }
    if (selectedVillage) {
      return villageMatch;
    } else if (selectedBlockCode) {
      return districtMatch && blockMatch;
    } else if (selectedDistrictCode) {
      return districtMatch;
    }
    return true;
  });
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const paginatedData = filteredRecords.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <style>
        {`
          .MuiTablePagination-actions svg {
            visibility: visible !important;
            fill: #212128;  
          }
        `}
      </style>

      <div className="container-fluid" style={{ height: "91vh" }}>
        {/* <h2 className="pt-10" style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold" }}>Line Department Details</h2> */}
        <div style={{ padding: '16px', marginTop: "-17px", }}>
          <h2 className="pt-10" style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold" }}>
            Line Department Details
          </h2>
        </div>

        <div>
          <div className="container-fluid mt-3 p-0">
            <div className="sticky-top bg-white py-3">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="mb-0"> </h4>
                <div className="d-flex">
                  <div className="me-3">
                    <select
                      className="form-select dropdown-custom"
                      value={selectedDistrictCode}
                      onChange={handleDistrictChange}
                    >
                      <option value="" disabled>Select District</option>
                      {district.map((item) => (
                        <option key={item.district_code} value={item.district_code}>
                          {item.district}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="me-3">
                    <select
                      className="form-select dropdown-custom"
                      value={selectedBlockCode}
                      onChange={handleBlockChange}
                    >
                      <option value="" disabled>Select Block</option>
                      {block.map((item) => (
                        <option key={item.block_code} value={item.block_code}>
                          {item.block}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="me-3">
                    <select
                      className="form-select dropdown-custom"
                      value={selectedVillage}
                      onChange={handleVillageChange}
                    >
                      <option value="" disabled>Select Gram Panchayat</option>
                      {village.map((item) => (
                        <option key={item.village_code} value={item.village_code}>
                          {item.gram_panchayat}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive " style={{ overflowX: "auto", maxHeight: "70vh", marginTop: "20px" }}>
              <Table aria-label="simple table">
                <TableHead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    backgroundColor: "rgb(232 233 246)",
                  }}
                >
                  <TableRow>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                      SR NO.
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                      DEPARTMENT NAME
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                      OFFICER NAME
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                      DESIGNATION
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                      MOBILE NUMBER
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                      EMAIL ID
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                      ENTITY TYPE
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                      DISTRICT
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                      BLOCK
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                      GRAM PANCHAYAT
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                      ACTIVE STATUS
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData.length > 0 ? (
                    paginatedData.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                          {index + 1 + (page * rowsPerPage)}
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                          {row.department_name}
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                          {row.full_name}
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                          {row.customDesignation || row.designation}
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                          {row.mobile_no}
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                          {row.email}
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center">
                          {row.entity_type}
                        </TableCell>
                        <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                          {row.district || '----------'}
                        </TableCell>
                        <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                          {row.block || '----------'}
                        </TableCell>
                        <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                          {row.gram_panchayat !== null && row.gram_panchayat !== undefined ? row.gram_panchayat : '----------'}
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }} align="center" className="custom-class">
                          {row.is_active === 1 ? "Active" : "Inactive"}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={11} align="center">
                        No data found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
            <TablePagination rowsPerPageOptions={[5, 10, 25]} component="div" count={filteredData.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} showFirstButton showLastButton components={{ FirstPageIcon: FirstPage, LastPageIcon: LastPage, NextPageIcon: KeyboardArrowRight, BackPageIcon: KeyboardArrowLeft, }} />
          </div>
        </div>
      </div>
    </>
  );
};
export default FrontlineWorkerOfficerAdmin;
